import React from "react";
import FileFieldmanager
    from "lib/dataentry/lib/dataentryform/formitems/FileField/manager";

export const FileFieldlabel = props =>
    <FileFieldmanager {...props} readOnly />;

export default FileFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/FileField/label.js